import { DELIVERY_DATA } from './liore-delivery-data.js?v=20260824';
import { buildDeliveryEstimate, tallinnToday } from './liore-delivery-calculator.js?v=20260824';

class LioreDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.render();
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener('shopify:product:select', this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener('shopify:product:select', this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    event.promise
      ?.then(({ detail }) => {
        const productId = this.dataset.productId;
        if (!detail?.html || !productId) return;

        const nextEstimate = [...detail.html.querySelectorAll('liore-delivery-estimate')]
          .find((element) => element.dataset.productId === productId);
        if (nextEstimate) this.replaceWith(nextEstimate);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[liore-delivery-estimate]', error);
      });
  };

  render() {
    const arrival = this.querySelector('[data-delivery-arrival]');
    if (!arrival || this.dataset.localStock !== 'true') return;

    const estimate = buildDeliveryEstimate({
      localStock: true,
      today: tallinnToday(),
      countryCode: this.dataset.countryCode || '',
      countryName: this.dataset.countryName || '',
      locale: this.dataset.locale || 'en',
      template: this.dataset.arrivalTemplate || '',
    }, DELIVERY_DATA);

    if (estimate) arrival.textContent = estimate;
  }
}

if (!customElements.get('liore-delivery-estimate')) {
  customElements.define('liore-delivery-estimate', LioreDeliveryEstimate);
}
